class CountdownTimer extends HTMLElement {
  connectedCallback() {
    const endDateStr = this.dataset.time;
    const targetDate = new Date(endDateStr);

    this.daysEl = this.querySelector(".days");
    this.hoursEl = this.querySelector(".hours");
    this.minutesEl = this.querySelector(".minutes");
    this.secondsEl = this.querySelector(".seconds");

    this.updateCountdown(targetDate);
    this.interval = setInterval(() => this.updateCountdown(targetDate), 1000);
  }

  updateCountdown(targetDate) {
    const now = new Date().getTime();
    const distance = targetDate.getTime() - now;

    if (distance <= 0) {
      this.querySelectorAll("span").forEach(el => {
        if (!el.classList.contains("text")) el.textContent = "0";
      });
      clearInterval(this.interval);
      this.dispatchEvent(new CustomEvent("countdown-ended", { bubbles: true }));
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (this.daysEl) this.daysEl.textContent = days;
    if (this.hoursEl) this.hoursEl.textContent = hours;
    if (this.minutesEl) this.minutesEl.textContent = minutes;
    if (this.secondsEl) this.secondsEl.textContent = seconds;
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }
}

customElements.define("countdown-timer", CountdownTimer);
